import { DateTime } from 'luxon';

export const currentYear = DateTime.local().year;
